import React from "react";


export interface IVariables {
  title: string;
  bold: string;
  afterTitle: string;
  img: string;
  prompt: string;
  typeImg: string;
  label: string;
  button: React.ReactNode;
  typeButton: string;
  message: string;
  errorMessage: React.ReactNode;
  succesImg: string;
  counter: number;
  errorCode: React.ReactNode;
  htmlElement: React.ReactNode;
}

export class Variables {
  elementary: IVariables;
  success: IVariables;
  confirmation?: IVariables;

  constructor(elementary?, success?, confirmation?) {
    this.elementary = elementary;
    this.success = success;
    this.confirmation = confirmation;
  }
  render() {
    return this.elementary, this.success, this.confirmation;
  }
}